//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters,mapActions } from "vuex";
import Model from '@/models/create'
export default {
    data() {
        return {
            updateData: {},
            carTime: '',
            realityMoney: '',
            submitState: false,
            rules: {
                unParkNo: [
                    { required: true, message: '车场名称不能为空', trigger: 'blur' }
                ],
                carNo: [
                    { required: true, message: '车牌号码不能为空', trigger: 'blur' },
                    {
                        validator:(rule,value,callback) => {
                            let telReg = new RegExp(/^1(3|4|5|7|8)\d{9}$/),
                                carNoReg = new RegExp(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳使领]{1}$/)
                            if(!carNoReg.test(value) && !telReg.test(value)) {
                                callback('请输入正确的车牌号或手机号')
                            }
                            callback()
                        },
                        trigger: 'blur'
                    }
                ],
                disMoney: [
                    { required: true, message: '优惠金额不能为空', trigger: 'blur' },
                    {
                        validator:(rule,value,callback) => {
                            if(value<0 || (value+'').indexOf('.')!=-1) {
                                callback('优惠金额必须大于0且不能为小数')
                            }
                            callback()
                        },
                        trigger: 'blur'
                    }
                ],
            }
        }
    },
    computed: {
        ...mapGetters('create',{
            carNoList: 'getCarNoList',
            parkList: 'getParkList'
        })
    },
    methods: {
        ...mapActions('user',{
            setUserBalance:'setUserBalanceAction'
        }),
        ...mapActions('create',{
            setCarNoListAction: 'setCarNoListAction',
            setParkListAction: 'setParkListAction'
        }),
        getCarNo() {
            this.setCarNoListAction({ unParkNo: this.updateData.unParkNo })
        },
        async getCarTime() {
            const { unParkNo, carNo } = this.updateData
            if(!unParkNo || !carNo) return;
            let { data } = await Model.getCarNoTime({ carNo, unParkNo });
            if(data.success) {
                this.carTime = data.list.inTime;
                this.realityMoney = data.list.realityMoney;
            }
        },
        async addDiscount(){
            if(this.submitState) return;
            this.submitState = true;
            let {data} = await Model.addDiscount(this.updateData);
            this.submitState = false;
            if(data.success){
                this.$refs.editForm.resetFields();
                this.setUserBalance(data.list)
            }
        },
        submit(){
            this.$refs.editForm.validate((err)=>{
                if(!err) return;
                this.addDiscount();
            })
        }
    },
    created() {
        this.setParkListAction()
    }
}



// WEBPACK FOOTER //
// ./src/pages/add/view.vue